import { render } from "./DefaultPlain.vue?vue&type=template&id=5c4649de&scoped=true"
import script from "./DefaultPlain.vue?vue&type=script&lang=js"
export * from "./DefaultPlain.vue?vue&type=script&lang=js"

import "./DefaultPlain.vue?vue&type=style&index=0&id=5c4649de&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4649de"]])

export default __exports__